<template>
    <AuthorPage
        :author="author"
        :page="page"
    />
</template>

<script setup>
import AuthorPage from '~/components/author-page/author-page.vue'

const route = useRoute()
const { author } = route.params

// Page 1 lives at /authors/<author>, so /page/1 (and any non-numeric or negative
// value) is not a real URL.
const page = Number(route.params.page)

if (!Number.isInteger(page) || page < 2) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}
</script>
